import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';

// import FullscreenIcon from '@mui/icons-material/Fullscreen';
// import { IconButton } from "@mui/material";
import { getImage } from "../../../service/api.service";
import { getSliceName, getValueOfSlice } from "../../common/codeHelper";
// import DcmDialog from "../Viewer/dcmDialog";
import DcmDialogWOCornerstone from "../Viewer/DcmDialogWOCornerstone";
import { ImageLazyLoad } from "../../common/ImageLazyLoad";


const styles = {
  topRightStyle: {
    top: "5px",
    right: "4px",
    position: "absolute",
    color: "white",
    fontSize: "10px",
    background: "rgb(44, 94, 210)",
    border: "1px solid #fff",
    borderRadius: "25px",
    height: "30px",
    width: "30px"
  },
  topLeftStyle: {
    top: "5px",
    left: "5px",
    position: "absolute",
    color: "white",
    fontSize: "10px",
    background: "#2b8f35",
    border: "1px solid #fff",
    borderRadius: "25px",
    height: "30px",
    width: "30px"
  },
  fullScreenButton: {
    padding: "3px 0px 0px 14px",
  },
  divStyle: {
    // width: "128px",
    // height: "200px",
    position: "relative",
    color: "white"
  },
  thumbnailDiv: {

  }
};
// let imageLoaded = false;
function Thumbnail(props) {
  // const [elementThumbnail, setElement] = useState("");
  const [idToFetchData, setIdToFetchData] = React.useState();
  const [extraData, setExtraData] = React.useState({ heading: '', height: '120', width: '120' });

  const state = {
    imageId: '',
    image: '',
    slice: props.data,
    // predicted_class: props.predictionText,
    value: props.data.value,
  };
  const [image, setImage] = useState(state.image);

  const CallBackToDcmComponent = () => {
    // props.parentCallback(props.imageIds);
  }

  const loadImage = () => {
    if (state.imageId !== props.data.fileIds[0]) {
      state.imageId = props.data.fileIds[0];
      // imageid = state.imageId;
      setIdToFetchData(props.data.fileIds[0]);
      getImage(props.data.fileIds[0], (resp) => {
 
        if (extraData.heading !== props.name)
          setExtraData({
            heading: props.name, height: resp.fileProperties.imageHeight,
            width: resp.fileProperties.imageWidth,
            value: getValueOfSlice(state.slice.descriptionText),
            key: getSliceName(state.slice.descriptionText)
          });

        state.image = 'data: image / png; base64,' + resp.fileData;
        setImage('data: image / png; base64,' + resp.fileData)
        // imageLoaded = true
      })
    }
  };

  useEffect(() => {
    // call api or anything
    // if (!imageLoaded) {
    loadImage(0);
    // }
  });




  return (
    <div className="thumbnail-div" style={styles.thumbnailDiv}>
      <Box>
        <div onClick={CallBackToDcmComponent} className="border border-gray-300 animate__animated animate__fadeIn shadow rounded ">
          <div className="p-2 ">
            <div className="font-semibold">
              Slice {state.slice.sliceNumber}
            </div>
            <p className="text-sm text-clip overflow-hidden" sx={{ textOverflow: 'ellipsis' }}>
              {
                getSliceName(state.slice.descriptionText) &&
                <div>
                  {getSliceName(state.slice.descriptionText).map(
                    (name, index) => {
                      return <div key={index}><b >{name}</b></div>
                    })
                  }
                </div>
              }
            </p>
            {
              getValueOfSlice(state.slice.descriptionText) &&
              <p className=" text-sm text-clip overflow-hidden" sx={{ textOverflow: 'ellipsis' }}>
                Value : <b>{getValueOfSlice(state.slice.descriptionText)}</b>
              </p>
            }
          </div>
          <div
            className="viewportElement"
            style={styles.divStyle}
            id="random"
          >

            <div style={styles.topLeftStyle} className="animate__animated animate__fadeIn">
              {/* <DcmDialog image={idToFetchData} extraData={extraData} ></DcmDialog> */}
              <DcmDialogWOCornerstone image={idToFetchData} extraData={extraData}></DcmDialogWOCornerstone>
              {/* <IconButton
                color="inherit"
                aria-label="Full Screen"
                style={styles.fullScreenButton}
                edge="start"
                onClick={() => requestFullScreenElem('original')}
              >
                <FullscreenIcon /> */}
              {/* </IconButton> */}
            </div>
            <ImageLazyLoad className="w-full h-full"
              placeholderImg="placeholder"
              src={image}></ImageLazyLoad>
              
          </div>
          

        </div>
      </Box>
    </div>
  );
}

export default Thumbnail;
